module.exports = __webpack_public_path__ + "img/Eisopa.6a3ef448.svg";